<template>
  <div class="operOrderTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button @click="save()" type="primary" class="vxe-btn-primary">{{
          $t('advanced.btnList.save')
        }}</vxe-button>
        <vxe-button
          @click="insertEvent()"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('advanced.btnList.add') }}</vxe-button
        >
        <vxe-button
          @click="handleDelete()"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >{{ $t('advanced.btnList.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="operOrderTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :loading="load"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      :edit-rules="rules"
      highlight-current-row
      @current-change="currentChange"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      max-height="400"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/moneyDraw';

  export default {
    name: 'operOrderTable',
    components: {},
    data() {
      return {
        load: false,
        tableData: [],
        eventOptions: [],
        interestOrderOptions: [],
        del: [],
      };
    },
    computed: {
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'eventCode',
            title: this.$t('advanced.operOrderTable.event'),
            editRender: {
              name: 'ElSelect',
              options: this.eventOptions,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            field: 'interestOrderCode',
            title: this.$t('advanced.operOrderTable.interestOrder'),
            editRender: {
              name: 'ElSelect',
              options: this.interestOrderOptions,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
        ];
      },
      rules() {
        return {
          eventCode: [
            { required: true, message: this.$t('advanced.operOrderTable.eventPlaceholder') },
          ],
          interestOrderCode: [
            {
              required: true,
              message: this.$t('advanced.operOrderTable.interestOrderPlaceholder'),
            },
          ],
        };
      },
    },
    mounted() {
      this.getData();
      this.getEvent();
      this.getInterestOrder();
    },
    methods: {
      async getData() {
        this.load = true;
        let res = await this.$axios.post(API.QUERY_EVENTORDER);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data;
          }
        }
      },
      // 获取计息事件数据
      async getEvent() {
        let res = await this.$axios.post(API.QUERY_INTERESTEVENTTYPE);
        if (res) {
          if (res.data.code == 0) {
            this.eventOptions = res.data.data;
            if (this.eventOptions.length > 0) {
              this.eventOptions = this.eventOptions.map((item) => {
                item['value'] = item.eventCode;
                item['label'] = item.eventName;
                return item;
              });
            }
          }
        }
      },
      // 获取计息单据数据
      async getInterestOrder() {
        let res = await this.$axios.post(API.QUERY_INTERESTORDERTYPE);
        if (res) {
          if (res.data.code == 0) {
            this.interestOrderOptions = res.data.data;
            if (this.interestOrderOptions.length > 0) {
              this.interestOrderOptions = this.interestOrderOptions.map((item) => {
                item['value'] = item.interestOrderCode;
                item['label'] = item.interestOrderName;
                return item;
              });
            }
          }
        }
      },
      // 表格新增一行
      insertEvent(row) {
        this.$refs.operOrderTable.validate((valid) => {
          if (valid) {
            let record = {
              eventCode: null,
              interestOrderCode: null,
            };
            this.$refs.operOrderTable.insertAt(record, row).then(({ row }) => {
              this.$refs.operOrderTable.setActiveRow(row);
            });
          }
        });
      },
      // 表格删除
      handleDelete() {
        const selectedList = this.$refs.operOrderTable.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('advanced.msg.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            selectedList.map((item) => {
              if (item.id) {
                this.del.push(item.id);
              }
            });
            this.$refs.operOrderTable.removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('advanced.msg.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('advanced.msg.cancelled'),
            });
          });
      },
      async save() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_EVENTORDER, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.getData();
            this.$parent.eventOrderId = null;
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.operOrderTable.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.operOrderTable.validate((valid) => {
            if (valid) {
              let param = {
                list: tableData,
                ids: this.del,
              };
              resolve(param);
            }
          });
        });
      },
      currentChange(val) {
        let id = val.row.id ? val.row.id : '';
        this.$emit('row-change', id);
      },
      toggleSelection(rows) {
        rows.forEach((row) => {
          console.log(row);
          if (row.index === 1) {
            this.$refs.operOrderTable.toggleRowSelection(row, true);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
